import { ActionList, Divider } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { AboutCertn } from "./AboutCertn";
import { DeleteAccount } from "./DeleteAccount";
import { DisputeReportResults } from "./DisputeReportResults";
import { GeneralFeedback } from "./GeneralFeedback";
import { HelpCenterButton } from "./HelpCenterButton";
import { PrivacyPolicy } from "./PrivacyPolicy";
import { ReportAProblem } from "./ReportAProblem";
import { RequestPersonalData } from "./RequestPersonalData";
import { TermsOfUse } from "./TermsOfUse";
import { TitleBar } from "./TitleBar";
import { AppTitle } from "../../../components/AppTitle";
import { useDocumentTitle } from "../../../hooks/api/useDocumentTitle";

export function HelpPrivacyPage() {
  const { t } = useTranslation();
  useDocumentTitle(`Certn ${t("Help & Privacy")}`);
  return (
    <>
      <TitleBar>
        <AppTitle title={t("Help & privacy")} />
        <HelpCenterButton />
      </TitleBar>
      <ActionList ariaLabel={t("Help & privacy")}>
        <ReportAProblem />
        <Divider />
        <GeneralFeedback />
        <Divider />
        <AboutCertn />
        <Divider />
        <PrivacyPolicy />
        <Divider />
        <TermsOfUse />
        <Divider />
        <DisputeReportResults />
        <Divider />
        <RequestPersonalData />
        <Divider />
        <DeleteAccount />
      </ActionList>
    </>
  );
}
